<script setup>

import { defineProps, onMounted, onUpdated } from "vue"

import Button from "@/components/Button.vue";
import i18n from "@/plugins/i18n";
import {useSwal} from "@/composables/useSwal";
import {useStore} from "vuex";

const {showSwal} = useSwal()

const store = useStore()
const props = defineProps({
  conversationId: {
    type: String,
    required: true,
  },
  messageId: {
    type: String,
    required: true,
  },
  share: Function,
  edit: Function,
  canEdit: {
    type: Boolean,
    default: false
  },
  isMe: {
    type: Boolean,
    default: false
  }
})

function deleteMessage() {
  showSwal(
      i18n.global.t('swal.chat.chat_discussion_msg_deleted'),
      i18n.global.t('swal.chat.chat_discussion_msg_deleted_text')
  ).then( async (result) => {
    if (result.value) {
      const data = {
        conversationId: props.conversationId,
        messageId: props.messageId,
      }
      store.dispatch('chat/deleteMessage', data)
          .then(() => {
            window.toastr['success'](i18n.global.t('notification.chat_discussion_msg_deleted'))
          })
          .catch(() => {

          })
    }
  })
}

function shareMsg() {
  if(props.share) {
    props.share()
  }
}

function editMsg() {
  if(props.edit) {
    props.edit()
  }
}


onMounted(() => {
  KTMenu.init();
})

onUpdated(() => {
  KTMenu.init();
})

</script>

<template>
  <div :id="'message_action_menu'+messageId" class="mx-1">
    <button type="button"
            data-kt-menu-trigger="hover"
            data-kt-menu-placement="bottom-end"
            data-kt-menu-attach="parent"
            class="btn btn-outline-primary bg-hover-light btn-icon">
      <i class="fa fa-ellipsis-h fs-2"></i>
    </button>

    <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-150px py-4" data-kt-menu="true">
      <div class="menu-item px-3">
        <a @click.prevent="shareMsg" href="#" class="menu-link px-3">
          <span>
            <span class="me-4 fs-3 "><i class="fa fa-share"></i></span>
            <span> Transferer </span>
          </span>
        </a>
        <a v-if="canEdit && isMe" @click.prevent.exact="editMsg" href="#" class="menu-link px-3">
          <span>
            <span class="me-4 fs-3 "><i class="fa fa-edit"></i></span>
            <span> Editer </span>
          </span>
        </a>
        <a v-if="isMe" @click.prevent.exact="deleteMessage" href="#" class="menu-link px-3">
          <span class="text-danger">
            <span class="me-4 fs-3 "><i class="fa fa-trash text-danger"></i></span>
            <span> Supprimer </span>
          </span>
        </a>

      </div>

    </div>
  </div>


</template>

<style scoped>

</style>